import React from "react";
import "./styles.css";

const TextContent = () => {
    return (
        <span className="text_content">
            Waiting for another player to join... <br /><br />
            Please wait while we match you with another participant. <br /><br />
            ⏱️ <strong>This may take a couple of minutes.</strong> <br /><br />
            🔄 Stay on this page. The game will launch automatically. <br /><br />
            <div className="sound-warning">
                🔊 <strong>Sound notification will play when matched. Increase device volume.</strong>
            </div>
        </span>
    );
}

export default React.memo(TextContent);